/** A tiny publish/subscribe channel so low-level modules (api, errors) can talk to the UI without importing it. */
const listeners = new Map();

export const bus = {
  on(event, fn) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event).add(fn);
    return () => listeners.get(event)?.delete(fn);
  },
  emit(event, payload) {
    for (const fn of listeners.get(event) ?? []) {
      try {
        fn(payload);
      } catch (error) {
        console.error(`bus listener for "${event}" failed`, error);
      }
    }
  },
};
